export const SWIPE_MIN_OFFSET = 5;
export const SWIPE_MIN_DISTANCE = 60;
export const SWIPE_MIN_VELOCITY = 500;
export const DEFAULT_DRAWER_WIDTH = '80%';
//# sourceMappingURL=constants.js.map